'use client';

import type { HousingPropertyDetail } from '@eliadmin/core/src/api/housing/housing-types';

import { Paragraph } from '@eliadmin/core/src/components/ui/paragraph';
import { cn } from '@eliadmin/core/src/utils/style-utils';

export function HousingTabDescription({ housing }: { housing: HousingPropertyDetail }) {
  return (
    <Paragraph
      innerHtml={housing?.description}
      className={cn('w-full', 'ea-generic-formatting')}
      color="secondary"
    />
  );
}
